import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const CardsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  width: 100%;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
    align-items: center;
  }
`
